/*
This file can be used for both vue2 and vue3
Contact Leela for any issues
*/

export class BonusOfferPopupSession {
  static bonusOfferSessionExists() {
    return !!sessionStorage.getItem(window.tid + '-EventDrivenPopup');
  }
  static setBonusOfferEventDrivenSession() {
    let key = window.tid + '-EventDrivenPopup';
    sessionStorage.setItem(key, window.tid);
  }
}
